/** The intro video (`/intro`, §17.4), in a new tab so a game in progress stays connected. */
export function IntroLink() {
  return (
    <a href="/intro" target="_blank" rel="noopener" data-testid="intro-link">
      How to play: the intro video
    </a>
  );
}
